<template>
<Teleport to="#modal-portal-target">
<div v-if="$store.getters['common/modalName'] === 'usergolfreservations'">
    <div class="modal-header">
        <h3 class="modal-title">
            {{ $_locale('your golf tee times') }}
        </h3>
    </div>
    <div class="modal-body reservation-modal userteetime-modal">
        <div class="panel-body" style="padding: 0;">
            <wn-table-pages 
                :items="golfReservations"
                :perPage="15"
                :pagingOptions="[15, 25, -1]">
                <template #head>
                    <th style="min-width: 65px;"></th>
                    <th>{{ $_locale('tee time') }}</th>
                    <th>{{ $_locale('player') }}</th>
                    <th>{{ $_locale('order number') }}</th>
                    <th>{{ $_locale('created') }}</th>
                    <th>{{ $_locale('orderer') }}</th>
                </template>
                <template v-slot="{ item: row }">
                    <tr :key="row.reservationTimeId">
                    <td>
                        <div style="padding: 10px 0;display:flex;">
                            <button class="btn btn-xs btn-success" 
                                v-if="[2].indexOf(row.status) > -1"
                                @click="confirmTeeTime(row.reservationTimeId)"
                                :disabled="!row.inFuture">
                                <i class="glyphicon glyphicon-ok"></i>
                                <span>{{ $_locale('confirm') }}</span>
                            </button>
                            <button class="btn btn-xs btn-default" 
                                v-if="[3].indexOf(row.status) > -1"
                                style="min-height: unset;"
                                :disabled="true">
                                <i class="glyphicon glyphicon-ok"></i>
                                <span>{{ $_locale('confirmed') }}</span>
                            </button>
                            <button class="btn btn-xs btn-danger" 
                                style="margin-left: 7px;"
                                v-if="[2,3].indexOf(row.status) > -1"
                                @click="deactivateReservationTime(row.reservationTimeId)"
                                :disabled="!row.inFuture">
                                <i class="glyphicon glyphicon-remove"></i>
                                <span>{{ $_locale('cancel') }}</span>
                            </button>
                        </div>
                    </td>
                    <td>
                        {{ $_formatDateTime($_dateFormat.DATETIME_DMYHI, row.dateTimeStart) }}
                    </td>
                    <td>{{ row.firstName }} {{ row.familyName }}</td>
                    <td style="text-align:right;">
                        <a v-bind:href="orderLinkUrl(row.orderId, row.hash)" target="_blank">
                            {{ row.orderId }}
                        </a>
                    </td>
                    <td>{{ $_formatDateTime($_dateFormat.DATETIME_DMYHI, row.dateCreated) }}</td>
                    <td>{{ row.reserverFirstName }} {{ row.reserverFamilyName }}</td>
                    </tr>
                </template>
            </wn-table-pages>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-default pull-left" 
            @click="$store.commit('common/setModal', null)">
            {{ $_locale('close') }}
        </button>
    </div>
</div>
</Teleport>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: () => ({
    }),
    computed: {
        ...mapGetters({
            modalIsOpen: 'common/modalIsOpen',
            modalName: 'common/modalName',
            adminMode: 'common/adminMode',
            orderLinkUrl: 'ecom/orderLinkUrl',
            golfReservations: 'golf/golfReservations',
        }),
    },
    watch: {
        modalIsOpen(val) {
            if (this.modalName !== 'usergolfreservations') return;
            
            if (val) {
                this.$store.dispatch('golf/getUserGolfReservations');
            } else {
                
            }
        },
    },
    methods: {
        confirmTeeTime(reservationTimeId) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            this.$_swal({
                title: _locale('confirm tee time').ucfirst() + '?',
                text: '',
                type: 'success',
                showCancelButton: true,
                confirmButtonClass: 'btn-warning',
                confirmButtonText: _locale('confirm').ucfirst(),
                cancelButtonText: _locale('close').ucfirst()
            })
            .then((result) => {
                if (result.isConfirmed) {
                    EcomService.confirmTeeTime(reservationTimeId)
                        .then((response) => {
                            const data = response.data;

                            if (data.success) {
                                this.$store.dispatch('golf/getUserGolfReservations');
                            } else {
                                this.$store.commit('common/setModal', null);
                                this.$_swal({ icon: 'error', title: data.message })
                            }
                        })
                }
            })
        },
        deactivateReservationTime(reservationTimeId) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            this.$_swal({
                title: _locale('are you sure').ucfirst(),
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn-warning',
                confirmButtonText: _locale('yes').ucfirst(),
                cancelButtonText: _locale('no').ucfirst()
            })
            .then((result) => {
                if (result.isConfirmed) {
                    EcomService.deactivateReservationTime(reservationTimeId)
                        .then((response) => {
                            const data = response.data;

                            if (data.success) {
                                this.$store.dispatch('golf/getUserGolfReservations');
                            } else {
                                this.$store.commit('common/setModal', null);
                                this.$_swal({ icon: 'error', title: data.message })
                            }
                        })
                }
            })
        },
    },
    mounted() {
    }
}
</script>